// @ts-check

import { computed } from 'vue'

/**
 * @template T
 * @param {import('vue').Ref<PaginationResponse<T> | null>} response
 */
export const usePaginationResponse = (response) => {
  const items = computed(() => response.value?.data)
  const meta = computed(() => response.value?.meta)
  const links = computed(() => response.value?.links)

  const firstPage = computed(() => links.value?.first)
  const lastPage = computed(() => links.value?.last)
  const nextPage = computed(() => links.value?.next)
  const previousPage = computed(() => links.value?.previous)

  const total = computed(() => meta.value?.total ?? 0)

  return {
    items,
    meta,
    links,
    total,
    firstPage,
    lastPage,
    nextPage,
    previousPage
  }
}

export default usePaginationResponse
